/* tslint:disable:max-classes-per-file */
define('util/convert',["require", "exports", "./cookie"], function (require, exports, cookie_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Unit = /** @class */ (function () {
        function Unit(units, label) {
            this.units = units;
            this.label = label;
        }
        Unit.prototype.localValue = function (m) {
            if (m === null || m === undefined) {
                return m;
            }
            else {
                return m * this.units;
            }
        };
        Unit.prototype.localString = function (m, precision) {
            if (precision === void 0) { precision = 0; }
            if (m === null || m === undefined || isNaN(m)) {
                return "";
            }
            else {
                return (this.units * m).toFixed(precision) + " " + this.label;
            }
        };
        return Unit;
    }());
    var feet = new Unit(3.28084, "ft");
    var meters = new Unit(1, "m");
    var mph = new Unit(2.23694, "mph");
    var kph = new Unit(3.6, "km/h");
    var glide = new Unit(1, ": 1");
    var UnitSystem = /** @class */ (function () {
        function UnitSystem(system, distance, speed, glideUnit) {
            this.system = system;
            this.distance = distance;
            this.speed = speed;
            this.glide = glideUnit;
        }
        return UnitSystem;
    }());
    var imperial = new UnitSystem("imperial", feet, mph, glide);
    var metric = new UnitSystem("metric", meters, kph, glide);
    var unitSystem = cookie_1.default.get("BASELINE_METRIC") ? metric : imperial;
    exports.default = unitSystem;
});
//# sourceMappingURL=/assets/javascripts/util/convert.js.map;
